export default {
      id: "icon-glace-usage",
      viewBox: "0 0 66.9 136.6",
      url: __webpack_public_path__ + "icons.svg#icon-glace",
      toString: function () {
        return this.url;
      }
    }